import { motion } from "framer-motion";

const featured = {
  bio1: "Heather Harris is an industry and technology leader driving innovation at the intersection of artificial intelligence and public sector mission delivery. She has spearheaded Google AI leadership initiatives that enhance productivity at federal scale, helping government agencies operate faster, smarter, and more efficiently. Throughout her career, Heather has partnered with both government and commercial customers to deliver digital and mission-driven innovations that solve complex challenges and advance organizational goals.",
  bio2: "A recognized expert in corporate facilities, Heather has a proven track record of providing innovative solutions to a variety of clients throughout her career, including Bloomberg, Amazon, Leidos, Volkswagen, and Raytheon/RTX. Her leadership reflects a deep commitment to harnessing emerging technologies to create meaningful, lasting impact across the public and private sectors.",
  education: "Heather holds a Master of Architecture (M.Arch I) from the City College of New York, where she graduated Summa Cum Laude. She is also a member of the Golden Key National Honor Society.",
};

const ricardo = {
  bio1: "Ricardo Holt serves as President of Harris Holt Intelligence, where he leads a team of professionals developing programs for U.S. federal agencies and the Intelligence Community. His work spans classified programs in artificial intelligence, cybersecurity, software development, cloud innovation, deep analytics, intelligence analysis, and architectural design.",
  bio2: "With more than 20 years of experience in dynamic business leadership, Holt has advanced engineering and architectural strategies that drive technology innovation and address some of the nation's most complex challenges. Prior to his current role, he held senior leadership positions at Verizon, Cisco Systems, Mitsui Sumitomo, and United States Federal Government, where he oversaw cybersecurity and analytics, national solutions, and homeland security business areas. In these roles, he led the delivery of advanced software solutions, integrated technology platforms, and analytic services for key agencies across the Intelligence Community.",
  bio3: "Over a 20-year career spanning engineering, infrastructure architecture, and executive leadership, Holt has led technology, innovation, and research portfolios while serving in leadership roles across international business and intelligence divisions. He has provided strategic direction, technical oversight, and customer engagement for programs centered on systems engineering, infrastructure modernization, technology architecture, software development, and cybersecurity solutions.",
  credentials: "Holt holds an AI/Python and Cybersecurity certificate from Harvard Online, along with credentials as a Google Generative AI Leader, Google AI Professional, Google Deep Mind, Claude AI, and Open AI. He is a prominent leader in the fields of AI, cybersecurity, and intelligence.",
};

export const Leadership = () => (
  <section id="leadership" data-testid="leadership-section" className="py-24 md:py-32 px-6 md:px-12 border-t border-black/10">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
        className="max-w-3xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#0891B2] mb-4">Company / Leadership</p>
        <h2 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950">
          Leadership built for the mission
        </h2>
        <p className="mt-6 text-[19px] leading-relaxed text-zinc-600">
          Our leadership team combines decades of federal and commercial
          technology experience, guiding Harris Holt's growth engines and
          mission delivery.
        </p>
      </motion.div>

      <motion.div
        data-testid="leader-heather-harris"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
        className="mt-16 bg-[#D4D4D8] border border-black/10 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-10 hover:border-black/30 transition-colors"
      >
        <div className="lg:col-span-4">
          <img
            src="/heather-harris.jpeg"
            alt="Heather Harris, Chief Executive Officer"
            className="w-full max-w-sm aspect-square object-cover object-top border-2 border-[#0891B2] mb-6"
          />
          <h3 className="text-3xl font-heading font-bold tracking-tight text-zinc-950">Heather Harris</h3>
          <p className="mt-1 font-mono text-sm uppercase tracking-[0.15em] text-[#0891B2]">Chief Executive Officer</p>
          <div className="mt-10 border-t border-black/10 pt-6">
            <p className="font-mono text-sm uppercase tracking-[0.2em] text-zinc-500 mb-3">Education &amp; Honors</p>
            <p className="text-[19px] leading-relaxed text-zinc-600">{featured.education}</p>
          </div>
        </div>
        <div className="lg:col-span-8 flex flex-col gap-5">
          <p className="text-[19px] leading-relaxed text-zinc-600">{featured.bio1}</p>
          <p className="text-[19px] leading-relaxed text-zinc-600">{featured.bio2}</p>
        </div>
      </motion.div>

      <motion.div
        data-testid="leader-ricardo-holt"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
        className="mt-6 bg-[#D4D4D8] border border-black/10 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-12 gap-10 hover:border-black/30 transition-colors"
      >
        <div className="lg:col-span-4">
          <img
            src="/ricardo-holt.jpeg"
            alt="Ricardo Holt, President of Intelligence"
            className="w-full max-w-sm aspect-square object-cover object-top border-2 border-[#0891B2] mb-6"
          />
          <h3 className="text-3xl font-heading font-bold tracking-tight text-zinc-950">Ricardo Holt</h3>
          <p className="mt-1 font-mono text-sm uppercase tracking-[0.15em] text-[#0891B2]">President, Intelligence</p>
          <div className="mt-10 border-t border-black/10 pt-6">
            <p className="font-mono text-sm uppercase tracking-[0.2em] text-zinc-500 mb-3">Education &amp; Credentials</p>
            <p className="text-[19px] leading-relaxed text-zinc-600">{ricardo.credentials}</p>
          </div>
        </div>
        <div className="lg:col-span-8 flex flex-col gap-5">
          <p className="text-[19px] leading-relaxed text-zinc-600">{ricardo.bio1}</p>
          <p className="text-[19px] leading-relaxed text-zinc-600">{ricardo.bio2}</p>
          <p className="text-[19px] leading-relaxed text-zinc-600">{ricardo.bio3}</p>
        </div>
      </motion.div>
    </div>
  </section>
);
